import { Link } from 'react-router-dom'
import { RootState } from 'store'
import { useAppDispatch } from 'store/hooks'
import { actions } from 'store/dashboard'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Title from 'components/title/Title'
import { Typography } from '@mui/material'
import Grid from '@mui/material/Grid'

import LockIcon from '@mui/icons-material/Lock'
import { useSelector } from 'react-redux'
import { useEffect } from 'react'
import { DashboardData } from 'store/dashboard/types'

import RecentCompanySearchesCard from './components/recentCompanySearchesCard/RecentCompanySearchesCard'
import RecentSinglePatentSearchesCard from './components/RecentSinglePatentSearchesCard'
import SectionCard from './components/SectionCard'
import IntegrationsCard from './components/IntegrationsCard'

type Props = {
  title: string
  dashboardData: DashboardData | null
}
function CompanyCard({ dashboardData }: Props) {
  return (
    <SectionCard title="Company searches">
      <Typography variant="body2">Total company reports</Typography>
      <Typography variant="h4">{dashboardData?.companySearches.count}</Typography>
      <br />
      <Button variant="contained" sx={{ mr: 5 }} component={Link} to="/company/search">
        Create search
      </Button>
      <Button component={Link} to="/dashboard/reporting/company">
        Company reports
      </Button>
    </SectionCard>
  )
}

function SinglePatentCard({ dashboardData }: Props) {
  return (
    <SectionCard title="Single patent searches">
      <Typography variant="body2">Total single patent reports</Typography>
      <Typography variant="h4">{dashboardData?.singlePatentSearches.count}</Typography>

      <br />
      <Button variant="contained" sx={{ mr: 5 }} component={Link} to="/report">
        Create search
      </Button>
      <Button component={Link} to="/dashboard/reporting/single-search">
        Single patent reports
      </Button>
    </SectionCard>
  )
}

function UserFeedbackCard() {
  return (
    <SectionCard title="User feedback" lock>
      <Typography variant="body2">Help shape the product – share feedback or suggest features.</Typography>
      <br />
      <Button variant="contained" sx={{ mr: 5 }} component={Link} to="/report">
        Feedback
      </Button>
      <LockIcon fontSize="medium" sx={{ position: 'absolute', top: '16px', right: '16px', color: 'rgb(16, 163, 127)' }} />
    </SectionCard>
  )
}

export default function Dashboard() {
  const dispatch = useAppDispatch()

  const dashboardData = useSelector((state: RootState) => state.dashboard.dashboardData)

  useEffect(() => {
    dispatch(actions.fetchDashboardData())

    const interval = setInterval(() => {
      dispatch(actions.fetchDashboardData())
    }, 10 * 1000)
    return () => clearInterval(interval)
  }, [dispatch])

  const cards = [
    <CompanyCard title="Company searches" dashboardData={dashboardData} />,
    <RecentCompanySearchesCard dashboardData={dashboardData} />,
    <SinglePatentCard title="Single patent searches" dashboardData={dashboardData} />,
    <RecentSinglePatentSearchesCard dashboardData={dashboardData} />,
    <IntegrationsCard />,

    <UserFeedbackCard />,
  ]
  return (
    <Box
      sx={{
        flexGrow: 1,
        display: 'flex',
        justifyContent: 'center',
        px: 6,
        py: 9,
      }}>
      <Box sx={{ maxWidth: 1000, width: '100%' }}>
        <Title>Dashboard</Title>
        <Grid mt={2} container spacing={2} columns={{ xs: 4, sm: 6, md: 12 }}>
          {cards.map((card, index) => (
            <Grid size={{ xs: 4, md: 6 }} key={index}>
              {card}
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  )
}
